import FindLoads from "@/pages/FindLoads";

export default function AdminLoadBoard() {
  return <FindLoads adminMode />;
}